import { getLocale } from "../runtime";

const sv_verifyingpurchase = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Verifierar köp, vänligen vänta...`
};

const verifyingpurchase = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_verifyingpurchase(inputs)
	return "verifyingPurchase";
};

export { verifyingpurchase as "verifyingPurchase" };